import { render, staticRenderFns } from "./courseUsageStatistics.vue?vue&type=template&id=7f112494"
import script from "./courseUsageStatistics.vue?vue&type=script&lang=js"
export * from "./courseUsageStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports